namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmPosta extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmPostaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmPostaObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmPostaObj());
            this.detailObj.createBase({
                contentName: "detailAdmPosta",
                contentCaption: "jres:29802653",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmPosta", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmPostaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmPostaReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format((this.data.stat) ? this.data["stat"] : "", (this.data.psc) ? this.data["psc"] : "")
        }

        setSxsDetail(): string {
            return "{0}#{1}#".format((this.data.stat) ? this.data.stat : "", (this.data.psc) ? this.data.psc : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmPostaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmPosta.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmPosta", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmPosta.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.posta) ? this.data.posta : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("stat", Gordic.Prefabs.Select.gincsta(), {
                dropdown: true,
                model: "model.stat=value.stat",
                change: (ev, changeobj) => {
                    if (changeobj.value) {
                        if (!Array.isArray(changeobj.value)) {
                            if (changeobj.value.stat == 42)   // kdy� je st�t �esko kontroluje se PS� jestli je 5 m�stn� a ��slice
                                this.cnt.findFields("psc").gfield("option", { validators: [new Gordic.Validators.Required({ stopping: true }), this.MakeSpecialValidator(changeobj.value.stat_txt)] })
                            else
                                this.cnt.findFields("psc").gfield("option", { validators: [new Gordic.Validators.Required({ stopping: true })] })
                            this.cnt.findFields("psc").gfield("validate");
                        }
                    }
                }
            });
            this.MakeField("psc");
            this.MakeField("posta");
            this.MakeField("ofic_nazev");
            this.MakeSelectField("priz_indiv_prir", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_indiv_prir=value.priz_an" });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private MakeSpecialValidator(stat_txt: string | undefined | null): Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> {
            var val = new Gordic.Validators.Base({ message: "jres:33000088".format(stat_txt?.toString()) }) //RC 33000088 : Pro zemi {0} mus� b�t PS� 5 m�stn� ��slo.
            val.validate = (value, source) => {
                if (!isNaN(value)) {
                    if (new RegExp("^[0-9]{5}$").test(value.toString()) == true)
                        return true
                }
                return false;
            }
            val.stopping = true;
            return val;
        }
    }
}